<script>
	import * as Carousel from '$lib/components/ui/carousel';
	import rangeImage from '$lib/assets/golf/the-range-launceston.jpg?enhanced';
	import linksSunriseImage from '$lib/assets/golf/links-dunes-sunrise.jpg?enhanced';
	import rathoGreenImage from '$lib/assets/golf/ratho-farm-green.jpg?enhanced';
	import sevenMileCoastImage from '$lib/assets/golf/seven-mile-beach-coast.jpg?enhanced';
	import rossHotelImage from '$lib/assets/golf/man-o-ross-hotel.jpg?enhanced';
	import cascadeImage from '$lib/assets/golf/cascade-brewery.jpg?enhanced';
	import wrestPointImage from '$lib/assets/golf/wrest-point.jpg?enhanced';
	import wrestPointRoomImage from '$lib/assets/golf/wrest-point-room.jpg?enhanced';

	const slides = [
		{
			src: rangeImage,
			alt: 'Aerial view of The Range driving range and mini golf at Country Club Tasmania at sunrise',
			caption: 'The Range, Launceston'
		},
		{
			src: linksSunriseImage,
			alt: 'Golfers walking a dune-lined links fairway in Tasmania',
			caption: 'Barnbougle'
		},
		{
			src: rathoGreenImage,
			alt: 'A green at Ratho Farm golf course in Bothwell',
			caption: 'Ratho Farm, Bothwell'
		},
		{
			src: sevenMileCoastImage,
			alt: '7 Mile Beach golf course on the Tasmanian coast',
			caption: '7 Mile Beach'
		},
		{
			src: rossHotelImage,
			alt: "The Man O' Ross Hotel, a two-storey sandstone coaching inn in the village of Ross",
			caption: "Man O' Ross Hotel, Ross"
		},
		{
			src: cascadeImage,
			alt: 'Cascade Brewery beneath kunanyi / Mount Wellington, Hobart',
			caption: 'Cascade Brewery, Hobart'
		},
		{
			src: wrestPointImage,
			alt: 'Wrest Point on the Hobart waterfront at dusk',
			caption: 'Wrest Point, Hobart'
		},
		{
			src: wrestPointRoomImage,
			alt: 'A guest room at Wrest Point, Hobart',
			caption: 'Premium accommodation'
		}
	];
</script>

<section class="bg-secondary pb-16 pt-14 lg:pb-24 lg:pt-16">
	<div class="mx-auto max-w-7xl px-4">
		<Carousel.Root class="relative w-full" opts={{ loop: true, align: 'start' }}>
			<Carousel.Content class="-ml-4">
				{#each slides as slide}
					<Carousel.Item class="basis-full pl-4 sm:basis-1/2 lg:basis-1/3">
						<figure class="relative overflow-hidden rounded-2xl shadow-sm">
							<enhanced:img
								src={slide.src}
								alt={slide.alt}
								class="aspect-[4/3] w-full object-cover"
								sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
								loading="lazy"
							/>
							<figcaption
								class="absolute bottom-3 left-3 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-foreground"
							>
								{slide.caption}
							</figcaption>
						</figure>
					</Carousel.Item>
				{/each}
			</Carousel.Content>
			<Carousel.Previous class="left-4 right-auto top-1/2 -translate-y-1/2 sm:-left-6" />
			<Carousel.Next class="left-auto right-4 top-1/2 -translate-y-1/2 sm:-right-6" />
		</Carousel.Root>
	</div>
</section>
